import { Badge, Tooltip } from '@chakra-ui/react';
import type { JSX } from 'react';

import { lang } from '@lang';

type DepositLinkBadgeProps = {
	depositLink?: string | null;
};

export const DepositLinkBadge = (props: DepositLinkBadgeProps): JSX.Element | null => {
	const { depositLink } = props;
	const { label, tooltip } = lang.crm;

	// undefined means the API never reported the field (a build predating it) — that is not a confirmed
	// absence, and badging it "No deposit link" would be a lie. null/'' is a real absence.
	if (depositLink === undefined) return null;

	const hasDepositLink = Boolean(depositLink);

	return (
		<Tooltip label={hasDepositLink ? tooltip.depositLinkSet : tooltip.depositLinkMissing} placement="top">
			<Badge colorScheme={hasDepositLink ? 'green' : 'orange'} fontSize="xs">
				{hasDepositLink ? label.depositLinkSet : label.depositLinkMissing}
			</Badge>
		</Tooltip>
	);
};
